module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-backoffice-client-list row column"
  }, [_c('cards', {
    attrs: {
      "data": _vm.parsedReports
    }
  }), _c('client-list-form', {
    on: {
      "setSearch": _vm.setSearch
    }
  }), _c('base-list', {
    attrs: {
      "component": _vm.component,
      "dataLoader": _vm.dataLoader,
      "search": _vm.search
    }
  }, [_c('header-columns', {
    attrs: {
      "slot": "before",
      "columns": _vm.headers
    },
    slot: "before"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0ddfdf54!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/ClientList.vue
// module id = 2135
// module chunks = 1